import type { PrintLayer } from "@pdfking/renderer-api"
import { RecordCreate, SortBy } from "@pdfking/tfunc"

import type { JobDestinationExt } from "#internal"
import type { DestinationID } from "#public"

import { JobDestinationList } from "../../data/JobDestinationList"

// Only the rendering fields cross over: the rest of the entry (id, file_name,
// name, print_mode) describes the destination, not the layer it prints on.
const build_print_layer = (d: JobDestinationExt, order: number): PrintLayer => {
  switch (d.print_mode) {
    case "print":
      return { enum: "print", order }
    case "overlay":
      return {
        enum: "overlay",
        order,
        guide_color: d.guide_color,
        print_color: d.print_color,
        print_roughness: d.print_roughness,
      }
    case "coating":
      return {
        enum: "coating",
        order,
        print_color: d.print_color,
        print_roughness: d.print_roughness,
      }
  }
}

/**
 * The layer each destination prints on. `order` is its place among the job's
 * destinations sorted by id (Python json.py: enumerate(sorted(destinations)));
 * unknown ids get no layer but still count.
 */
export const BuildPrintLayers = (
  destinations: DestinationID[]
): Record<DestinationID, PrintLayer> =>
  RecordCreate(
    SortBy(destinations).flatMap((id, order) => {
      const entry = JobDestinationList[id]
      return entry ? [[id, build_print_layer(entry, order)] as const] : []
    })
  )
